// extracted by mini-css-extract-plugin
export default {"editorScroll":"NoteLayout_editorScroll__tlGIb","editorNoScroll":"NoteLayout_editorNoScroll__ctcnx","alignCenter":"NoteLayout_alignCenter__zk3Wy"};